// src/pages/CrisprPage.jsx
import React, { useEffect, useRef, useState } from 'react';
import SlideOne from '../components/Cripsr/SlideOne';
import SlideTwo from '../components/Cripsr/SlideTwo';
import SplitScrollSlide from '../components/Cripsr/SplitScrollSlide';
import dotsBg from '../assets/images/website.gif';
import Navbar from '../components/Cripsr/NavbarCrispr';
import ArticleSection from '../components/Cripsr/ArticleSection';

const babyTexts = [
    `SIX YEARS AGO, THE NEWS OF THE FIRST CRISPR BABIES SHOCKED THE WORLD.\n\nON NOV. 25, 2018, A CHINESE RESEARCHER NAMED HE JIANKUI ANNOUNCED THE BIRTH OF THE WORLD’S FIRST GENE-EDITED BABIES — TWIN GIRLS NAMED LULU AND NANA.`,
    `THE BABIES HAD HAD THEIR GENOMES FOREVER ALTERED IN THE HOPES OF GIVING THEM A LIFETIME PROTECTION AGAINST HIV INFECTION — THE VIRUS THAT CAUSES AIDS.`,
    `JUST HOW, WHEN AND IF THE INTERNATIONAL HUMAN COMMUNITY CAN PUT THE GENOME-EDITING GENIE BACK IN THE BOTTLE REMAINS TO BE DETERMINED.`,
    `BUT WITH THE CRISPR QUILL FIRMLY IN HAND, SCIENTISTS ARE MOVING FORWARD TO REWRITE THE BOOK OF LIFE.`,
];

const babySplineUrl = 'https://prod.spline.design/TWqwAETwup-2Be-a/scene.splinecode';

const CrisprPage = () => {
    const scrollRef = useRef(null);
    const [isShrunk, setIsShrunk] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = scrollRef.current?.scrollTop || 0;
            setIsShrunk(scrollY > window.innerHeight * 0.6);
        };

        const scrollElement = scrollRef.current;
        scrollElement?.addEventListener('scroll', handleScroll);

        return () => {
            scrollElement?.removeEventListener('scroll', handleScroll);
        };
    }, []);
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (

        <div className="relative">
            {/* Fixed background */}

            <div
                className="fixed inset-0 z-0"
                style={{
                    backgroundImage: `url(${dotsBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            />

            <Navbar isShrunk={isShrunk} />

            {/* Content layers on top */}
            <div ref={scrollRef} className="relative z-10 h-screen overflow-y-scroll snap-y snap-mandatory scrollbar-none">
                <div className="snap-start">
                    <SlideOne />
                </div>
                <div className="snap-start">
                    <SlideTwo />
                </div>
                <div className="snap-start">
                    <SplitScrollSlide modelUrl={babySplineUrl} texts={babyTexts} />
                </div>
            </div>
            <div className="relative z-10 bg-white">
                <ArticleSection />
            </div>
        </div>

    );
};

export default CrisprPage;
